
// FAQ Toggle Function
function toggleFaq(header) {
    const faqItem = header.closest('.faq-item');
    const content = header.nextElementSibling;
    const toggleIcon = header.querySelector('.toggle-icon');
    const isActive = faqItem.classList.contains('active');

    // Close all FAQs
    document.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
    });

    document.querySelectorAll('.faq-content').forEach(item => {
        item.classList.remove('active');
    });

    document.querySelectorAll('.toggle-icon').forEach(icon => {
        icon.classList.remove('active');
    });

    // Open current only if it was closed
    if (!isActive) {
        faqItem.classList.add('active');
        content.classList.add('active');
        toggleIcon.classList.add('active');
    }
}
function handleEntry() {
    // Redirect to entry page or perform entry action
    window.location.href = "entry.html"; // Change to your entry page URL
}